var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiDocInt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_df_26508_230215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4.09522V16.9416C8 18.0972 8.93982 19.037 10.0954 19.037H15.4075C15.8168 19.037 16.1482 18.7055 16.1482 18.2962C16.1482 17.887 15.8168 17.5555 15.4075 17.5555H10.0954C9.7565 17.5555 9.48151 17.2796 9.48151 16.9416V4.09522C9.48151 3.75632 9.75745 3.48133 10.0954 3.48133H16.5187V5.91194C16.5187 6.81843 17.2558 7.55548 18.1623 7.55548H20.5929V13.1112C20.5929 13.5205 20.9244 13.852 21.3337 13.852C21.7429 13.852 22.0744 13.5205 22.0744 13.1112V6.87968C22.0744 6.32041 21.8559 5.79634 21.4568 5.40188L18.6244 2.60742C18.229 2.21575 17.7031 2 17.1429 2H10.0957C8.94008 2 8.00026 2.93982 8.00026 4.09539L8 4.09522ZM20.0298 6.07396H18.1631C18.0752 6.07396 18.0011 5.99989 18.0011 5.91192V4.07209L20.0308 6.07396L20.0298 6.07396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.09522V16.9416C8 18.0972 8.93982 19.037 10.0954 19.037H15.4075C15.8168 19.037 16.1482 18.7055 16.1482 18.2962C16.1482 17.887 15.8168 17.5555 15.4075 17.5555H10.0954C9.7565 17.5555 9.48151 17.2796 9.48151 16.9416V4.09522C9.48151 3.75632 9.75745 3.48133 10.0954 3.48133H16.5187V5.91194C16.5187 6.81843 17.2558 7.55548 18.1623 7.55548H20.5929V13.1112C20.5929 13.5205 20.9244 13.852 21.3337 13.852C21.7429 13.852 22.0744 13.5205 22.0744 13.1112V6.87968C22.0744 6.32041 21.8559 5.79634 21.4568 5.40188L18.6244 2.60742C18.229 2.21575 17.7031 2 17.1429 2H10.0957C8.94008 2 8.00026 2.93982 8.00026 4.09539L8 4.09522ZM20.0298 6.07396H18.1631C18.0752 6.07396 18.0011 5.99989 18.0011 5.91192V4.07209L20.0308 6.07396L20.0298 6.07396Z",
    fill: "url(#paint0_linear_26508_230215)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8033 19.0103C19.5228 19.4854 19.7746 19.7363 20.2496 21.4566C20.3385 21.7779 20.6301 22.0001 20.9635 22.0001C21.2968 22.0001 21.5885 21.7779 21.6774 21.4566C22.1524 19.7371 22.4033 19.4853 24.1236 19.0103C24.4449 18.9215 24.6672 18.6298 24.6672 18.2965C24.6672 17.9631 24.4449 17.6714 24.1236 17.5826C22.4042 17.1076 22.1523 16.8566 21.6774 15.1363C21.5885 14.815 21.2968 14.5928 20.9635 14.5928C20.6301 14.5928 20.3385 14.815 20.2496 15.1363C19.7746 16.8558 19.5236 17.1076 17.8033 17.5826C17.482 17.6714 17.2598 17.9631 17.2598 18.2965C17.2598 18.6298 17.482 18.9215 17.8033 19.0103ZM20.9635 17.3353C21.2154 17.739 21.5219 18.0446 21.9247 18.2965C21.521 18.5483 21.2154 18.8548 20.9635 19.2576C20.7117 18.8539 20.4052 18.5483 20.0024 18.2965C20.4061 18.0446 20.7117 17.7381 20.9635 17.3353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8033 19.0103C19.5228 19.4854 19.7746 19.7363 20.2496 21.4566C20.3385 21.7779 20.6301 22.0001 20.9635 22.0001C21.2968 22.0001 21.5885 21.7779 21.6774 21.4566C22.1524 19.7371 22.4033 19.4853 24.1236 19.0103C24.4449 18.9215 24.6672 18.6298 24.6672 18.2965C24.6672 17.9631 24.4449 17.6714 24.1236 17.5826C22.4042 17.1076 22.1523 16.8566 21.6774 15.1363C21.5885 14.815 21.2968 14.5928 20.9635 14.5928C20.6301 14.5928 20.3385 14.815 20.2496 15.1363C19.7746 16.8558 19.5236 17.1076 17.8033 17.5826C17.482 17.6714 17.2598 17.9631 17.2598 18.2965C17.2598 18.6298 17.482 18.9215 17.8033 19.0103ZM20.9635 17.3353C21.2154 17.739 21.5219 18.0446 21.9247 18.2965C21.521 18.5483 21.2154 18.8548 20.9635 19.2576C20.7117 18.8539 20.4052 18.5483 20.0024 18.2965C20.4061 18.0446 20.7117 17.7381 20.9635 17.3353Z",
    fill: "url(#paint1_linear_26508_230215)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1125 15.3325C19.1125 14.9233 18.7811 14.5918 18.3718 14.5918H11.3345C10.9252 14.5918 10.5938 14.9233 10.5938 15.3325C10.5938 15.7418 10.9252 16.0733 11.3345 16.0733H18.3718C18.7811 16.0733 19.1125 15.7418 19.1125 15.3325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1125 15.3325C19.1125 14.9233 18.7811 14.5918 18.3718 14.5918H11.3345C10.9252 14.5918 10.5938 14.9233 10.5938 15.3325C10.5938 15.7418 10.9252 16.0733 11.3345 16.0733H18.3718C18.7811 16.0733 19.1125 15.7418 19.1125 15.3325Z",
    fill: "url(#paint2_linear_26508_230215)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3718 11.6299H11.3345C10.9252 11.6299 10.5938 11.9614 10.5938 12.3706C10.5938 12.7799 10.9252 13.1114 11.3345 13.1114H18.3718C18.7811 13.1114 19.1125 12.7799 19.1125 12.3706C19.1125 11.9614 18.7811 11.6299 18.3718 11.6299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3718 11.6299H11.3345C10.9252 11.6299 10.5938 11.9614 10.5938 12.3706C10.5938 12.7799 10.9252 13.1114 11.3345 13.1114H18.3718C18.7811 13.1114 19.1125 12.7799 19.1125 12.3706C19.1125 11.9614 18.7811 11.6299 18.3718 11.6299Z",
    fill: "url(#paint3_linear_26508_230215)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3718 8.66602H11.3345C10.9252 8.66602 10.5938 8.99749 10.5938 9.40677C10.5938 9.81604 10.9252 10.1475 11.3345 10.1475H18.3718C18.7811 10.1475 19.1125 9.81604 19.1125 9.40677C19.1125 8.99749 18.7811 8.66602 18.3718 8.66602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3718 8.66602H11.3345C10.9252 8.66602 10.5938 8.99749 10.5938 9.40677C10.5938 9.81604 10.9252 10.1475 11.3345 10.1475H18.3718C18.7811 10.1475 19.1125 9.81604 19.1125 9.40677C19.1125 8.99749 18.7811 8.66602 18.3718 8.66602Z",
    fill: "url(#paint4_linear_26508_230215)",
    fillOpacity: 0.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.09522V16.9416C8 18.0972 8.93982 19.037 10.0954 19.037H15.4075C15.8168 19.037 16.1482 18.7055 16.1482 18.2962C16.1482 17.887 15.8168 17.5555 15.4075 17.5555H10.0954C9.7565 17.5555 9.48151 17.2796 9.48151 16.9416V4.09522C9.48151 3.75632 9.75745 3.48133 10.0954 3.48133H16.5187V5.91194C16.5187 6.81843 17.2558 7.55548 18.1623 7.55548H20.5929V13.1112C20.5929 13.5205 20.9244 13.852 21.3337 13.852C21.7429 13.852 22.0744 13.5205 22.0744 13.1112V6.87968C22.0744 6.32041 21.8559 5.79634 21.4568 5.40188L18.6244 2.60742C18.229 2.21575 17.7031 2 17.1429 2H10.0957C8.94008 2 8.00026 2.93982 8.00026 4.09539L8 4.09522ZM20.0298 6.07396H18.1631C18.0752 6.07396 18.0011 5.99989 18.0011 5.91192V4.07209L20.0308 6.07396L20.0298 6.07396Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.09522V16.9416C8 18.0972 8.93982 19.037 10.0954 19.037H15.4075C15.8168 19.037 16.1482 18.7055 16.1482 18.2962C16.1482 17.887 15.8168 17.5555 15.4075 17.5555H10.0954C9.7565 17.5555 9.48151 17.2796 9.48151 16.9416V4.09522C9.48151 3.75632 9.75745 3.48133 10.0954 3.48133H16.5187V5.91194C16.5187 6.81843 17.2558 7.55548 18.1623 7.55548H20.5929V13.1112C20.5929 13.5205 20.9244 13.852 21.3337 13.852C21.7429 13.852 22.0744 13.5205 22.0744 13.1112V6.87968C22.0744 6.32041 21.8559 5.79634 21.4568 5.40188L18.6244 2.60742C18.229 2.21575 17.7031 2 17.1429 2H10.0957C8.94008 2 8.00026 2.93982 8.00026 4.09539L8 4.09522ZM20.0298 6.07396H18.1631C18.0752 6.07396 18.0011 5.99989 18.0011 5.91192V4.07209L20.0308 6.07396L20.0298 6.07396Z",
    fill: "url(#paint5_linear_26508_230215)",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8033 19.0103C19.5228 19.4854 19.7746 19.7363 20.2496 21.4566C20.3385 21.7779 20.6301 22.0001 20.9635 22.0001C21.2968 22.0001 21.5885 21.7779 21.6774 21.4566C22.1524 19.7371 22.4033 19.4853 24.1236 19.0103C24.4449 18.9215 24.6672 18.6298 24.6672 18.2965C24.6672 17.9631 24.4449 17.6714 24.1236 17.5826C22.4042 17.1076 22.1523 16.8566 21.6774 15.1363C21.5885 14.815 21.2968 14.5928 20.9635 14.5928C20.6301 14.5928 20.3385 14.815 20.2496 15.1363C19.7746 16.8558 19.5236 17.1076 17.8033 17.5826C17.482 17.6714 17.2598 17.9631 17.2598 18.2965C17.2598 18.6298 17.482 18.9215 17.8033 19.0103ZM20.9635 17.3353C21.2154 17.739 21.5219 18.0446 21.9247 18.2965C21.521 18.5483 21.2154 18.8548 20.9635 19.2576C20.7117 18.8539 20.4052 18.5483 20.0024 18.2965C20.4061 18.0446 20.7117 17.7381 20.9635 17.3353Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8033 19.0103C19.5228 19.4854 19.7746 19.7363 20.2496 21.4566C20.3385 21.7779 20.6301 22.0001 20.9635 22.0001C21.2968 22.0001 21.5885 21.7779 21.6774 21.4566C22.1524 19.7371 22.4033 19.4853 24.1236 19.0103C24.4449 18.9215 24.6672 18.6298 24.6672 18.2965C24.6672 17.9631 24.4449 17.6714 24.1236 17.5826C22.4042 17.1076 22.1523 16.8566 21.6774 15.1363C21.5885 14.815 21.2968 14.5928 20.9635 14.5928C20.6301 14.5928 20.3385 14.815 20.2496 15.1363C19.7746 16.8558 19.5236 17.1076 17.8033 17.5826C17.482 17.6714 17.2598 17.9631 17.2598 18.2965C17.2598 18.6298 17.482 18.9215 17.8033 19.0103ZM20.9635 17.3353C21.2154 17.739 21.5219 18.0446 21.9247 18.2965C21.521 18.5483 21.2154 18.8548 20.9635 19.2576C20.7117 18.8539 20.4052 18.5483 20.0024 18.2965C20.4061 18.0446 20.7117 17.7381 20.9635 17.3353Z",
    fill: "url(#paint6_linear_26508_230215)",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1125 15.3325C19.1125 14.9233 18.7811 14.5918 18.3718 14.5918H11.3345C10.9252 14.5918 10.5938 14.9233 10.5938 15.3325C10.5938 15.7418 10.9252 16.0733 11.3345 16.0733H18.3718C18.7811 16.0733 19.1125 15.7418 19.1125 15.3325Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1125 15.3325C19.1125 14.9233 18.7811 14.5918 18.3718 14.5918H11.3345C10.9252 14.5918 10.5938 14.9233 10.5938 15.3325C10.5938 15.7418 10.9252 16.0733 11.3345 16.0733H18.3718C18.7811 16.0733 19.1125 15.7418 19.1125 15.3325Z",
    fill: "url(#paint7_linear_26508_230215)",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3718 11.6299H11.3345C10.9252 11.6299 10.5938 11.9614 10.5938 12.3706C10.5938 12.7799 10.9252 13.1114 11.3345 13.1114H18.3718C18.7811 13.1114 19.1125 12.7799 19.1125 12.3706C19.1125 11.9614 18.7811 11.6299 18.3718 11.6299Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3718 11.6299H11.3345C10.9252 11.6299 10.5938 11.9614 10.5938 12.3706C10.5938 12.7799 10.9252 13.1114 11.3345 13.1114H18.3718C18.7811 13.1114 19.1125 12.7799 19.1125 12.3706C19.1125 11.9614 18.7811 11.6299 18.3718 11.6299Z",
    fill: "url(#paint8_linear_26508_230215)",
    fillOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3718 8.66602H11.3345C10.9252 8.66602 10.5938 8.99749 10.5938 9.40677C10.5938 9.81604 10.9252 10.1475 11.3345 10.1475H18.3718C18.7811 10.1475 19.1125 9.81604 19.1125 9.40677C19.1125 8.99749 18.7811 8.66602 18.3718 8.66602Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3718 8.66602H11.3345C10.9252 8.66602 10.5938 8.99749 10.5938 9.40677C10.5938 9.81604 10.9252 10.1475 11.3345 10.1475H18.3718C18.7811 10.1475 19.1125 9.81604 19.1125 9.40677C19.1125 8.99749 18.7811 8.66602 18.3718 8.66602Z",
    fill: "url(#paint9_linear_26508_230215)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_26508_230215",
    x: 0,
    y: 0,
    width: 32.668,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.529412 0 0 0 0 0.745098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26508_230215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26508_230215",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_26508_230215"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26508_230215",
    x1: 7.56017,
    y1: 2,
    x2: 23.5812,
    y2: 15.9623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#AC2CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26508_230215",
    x1: 17.0283,
    y1: 14.5928,
    x2: 24.0498,
    y2: 22.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#AC2CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26508_230215",
    x1: 10.3275,
    y1: 14.5918,
    x2: 10.7789,
    y2: 17.3301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#AC2CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26508_230215",
    x1: 10.3275,
    y1: 11.6299,
    x2: 10.7789,
    y2: 14.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#AC2CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26508_230215",
    x1: 10.3275,
    y1: 8.66602,
    x2: 10.7789,
    y2: 11.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#AC2CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26508_230215",
    x1: 7.56017,
    y1: 2,
    x2: 23.5812,
    y2: 15.9623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#AC2CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26508_230215",
    x1: 17.0283,
    y1: 14.5928,
    x2: 24.0498,
    y2: 22.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#AC2CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26508_230215",
    x1: 10.3275,
    y1: 14.5918,
    x2: 10.7789,
    y2: 17.3301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#AC2CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26508_230215",
    x1: 10.3275,
    y1: 11.6299,
    x2: 10.7789,
    y2: 14.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#AC2CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26508_230215",
    x1: 10.3275,
    y1: 8.66602,
    x2: 10.7789,
    y2: 11.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#AC2CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B8EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiDocInt);
export default __webpack_public_path__ + "static/media/ai-doc-int.ee22912d442aacbe2554e7228d70b401.svg";
export { ForwardRef as ReactComponent };